/**
 * Mulberry32 — seedad, deterministisk PRNG. Tillståndet är ett uint32 som ligger
 * i GameState; varje dragning returnerar nytt tillstånd + värde. Ingen global state.
 */

export interface RngResult {
  state: number;
  value: number; // uint32
}

/** Nästa uint32 ur tillstånd `state`. */
export function rngNext(state: number): RngResult {
  let t = (state + 0x6d2b79f5) >>> 0;
  const newState = t;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = (t ^ (t >>> 14)) >>> 0;
  return { state: newState, value };
}

/** Heltal i [0, bound). bound måste vara >= 1. */
export function rngInt(state: number, bound: number): RngResult {
  const r = rngNext(state);
  return { state: r.state, value: r.value % bound };
}

/** Heltal i [min, max] (inklusivt). */
export function rngRange(state: number, min: number, max: number): RngResult {
  const r = rngInt(state, max - min + 1);
  return { state: r.state, value: min + r.value };
}
